import { useState } from 'react'
import './styles/drag.css'
import uploadIcon from '../assets/icons/upload.svg'

export default function DragAndDrop() {
    const [file,setFile] = useState(null)

    const fileHandler = (event) => {
        event.preventDefault()
        setFile(event.dataTransfer.files[0])
    }

    const uploadFile = (event) => {
        setFile(event.target.files[0])
    }

    const dragStartHandler = (event) => {
        event.preventDefault()
    }

    const dragLeaveHandler = (event) => {
        event.preventDefault()
    }
    
  return (
    <div 
        className="drag-form"> 
        <label 
        onDragStart={(e) => dragStartHandler(e)}
        onDragLeave={(e) => dragLeaveHandler(e)}
        onDragOver={(e) => dragStartHandler(e)}
        onDrop={(e) => fileHandler(e)} 
        className='drag-form__label' htmlFor="drag-input">
          <div className='drag-form__title'>Upload new resume</div>
          {
            file
            ?
            <div className='drag-form__file-name'>{file.name}</div>
            :
            <div className='drag-form__img'>
                <img src={uploadIcon} alt={'uploadIcon'}/>
            </div>
          }

            <div className='drag-form__comment'>
                Upload or drop pdf file here
            </div>
            <div className='drag-form__fake-btn'>Add from Computer</div>
        </label>
        <input onChange={uploadFile} id="drag-input" className="drag-input" type={'file'}/>
    </div> 
  )
}
